import { Card, Button, Space, Tooltip, message , Tree } from "antd";
import { ExpandAltOutlined, SyncOutlined, CompressOutlined } from "@ant-design/icons";
import styles from "./index.module.less";
import { useShallow } from "zustand/react/shallow";
import useStore from "@/pages/documentCompile/store/useStore";
import useMethods from "@/pages/documentCompile/onlyofficeFieldSetting/hooks/usemethods";
import { DocumentFileType, DomainFieldConfig } from "@/pages/documentCompile/type";
import { isShowDomainConfigByFileName } from "@/pages/documentCompile/utils/file";
import { useWhyDidYouUpdate } from "ahooks";

export default function DomainCard() {
    const setStoreState = useStore.setState
    const { handleMessage, handleFieldDoubleClick } = useMethods();
    const state = useStore(
        useShallow((s) => ({
            domainTreeData: s.domainTreeData,
            domainTreeDataExpandedKeys: s.domainTreeDataExpandedKeys,
            fieldValues: s.fieldValues,
            domainTreeCardExpanded: s.domainTreeCardExpanded,
            setDomainTreeCardExpanded: s.setDomainTreeCardExpanded,
        }))
    );
    const { domainTreeData, domainTreeDataExpandedKeys } = state
    // useWhyDidYouUpdate('useWhyDidYouUpdateComponent', { ...state })

    // 处理树节点双击
    const handleTreeNodeDoubleClick = (node: DomainFieldConfig) => {
        const latestDocumentSettingProjectData = useStore.getState().documentSettingProjectData
        const fileName = latestDocumentSettingProjectData.documentDetail?.fileName || latestDocumentSettingProjectData.documentDetail?.documentName || latestDocumentSettingProjectData.documentDetail?.name
        const isEditMode = useStore.getState().isEditMode
        if (!isEditMode) {
            message.warning('只读模式下，无法插入字段域');
            return;
        }
        if (!isShowDomainConfigByFileName(fileName)) {
            message.warning('该文件类型不支持字段域设置');
            return;
        }
        // const storeState = useStore.getState()
        const settingDomainFormData = useStore.getState().settingDomainFormData
        const settingProjectFormData = useStore.getState().settingProjectFormData
        const allFormData = {
            ...settingDomainFormData,
            ...settingProjectFormData
        }
        // console.log("storeState", storeState)
        if (node && !node.noField) {
            const currentValue = allFormData[node.fieldTag];
            // console.log("currentValue", currentValue)
            handleFieldDoubleClick?.(node, currentValue);
        }
        const usedDomainDocDataMap = useStore.getState().usedDomainDocDataMap
        const newUsedDomainDataMap = { ...usedDomainDocDataMap }
        if (node.fieldTag) {
            newUsedDomainDataMap[node.fieldTag] = node
        }

        // 同时更新domainFormData
        const newDomainFormData = { ...settingProjectFormData }
        if (!newDomainFormData[node.fieldTag]) {
            newDomainFormData[node.fieldTag] =  ''
        }
        setStoreState({
            // settingDomainFormData: newDomainFormData,
            usedDomainDocDataMap: newUsedDomainDataMap,
        })
    }

    // 处理卡片展开/折叠
    // const handleCardExpand = () => {
    //     setDomainTreeCardExpanded(!domainTreeCardExpanded);
    // };
    console.log("domainTreeData", domainTreeData);
    return (
        <Card
            className={styles.card}
            styles={{ body: { flex: 1, overflow: "auto" } }}
            title="域字段列表"
            size="small"
            style={{
                height: "100%",
                display: "flex",
                flexDirection: "column"
            }}
        >
            <div style={{ flex: 1, overflow: "auto", height: "100%" }}>
                {domainTreeDataExpandedKeys.length > 0 ? (
                    <Tree
                        className={styles.tree}
                        treeData={domainTreeData}
                        onDoubleClick={(e, node: any) => handleTreeNodeDoubleClick(node)}
                        defaultExpandedKeys={domainTreeDataExpandedKeys}
                        showLine
                        blockNode
                    />
                ) : null}
            </div>
        </Card>
    )
}